import React from 'react';
import styled from '@emotion/styled';
import {
	ChevronDownIcon,
	ChevronUpIcon,
	FixedGridItem,
	UnstyledButton,
} from '../../../../ui';
import { IFooterLinkSection } from './types/IFooterLinkSection';
import { FooterSectionHeader } from './FooterSectionHeader';
import { FooterLinkList } from './FooterLinkList';
import Responsive from '../../../../ui/utils/Responsive';
import { useTranslation } from '../../i18n/translate/useTranslation';
import { theme } from '../../styles';
import { handleKeyboardClick } from '../../../../ui/components/Accordion/helpers/handleKeyboardClick';

export const StyledFooterLinkSection = styled(FixedGridItem)`
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		border-bottom: 1px solid rgba(255, 255, 255, 0.5);
		padding-bottom: 16px;
	}
`;

const FooterSectionHeaderLinkDesktop = styled.div`
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
`;

const FooterSectionHeaderLink = styled(UnstyledButton)`
	display: none;

	svg {
		display: none;
	}

	&:focus-visible {
		outline: ${theme.button?.primary?.focus?.outline};
		border-radius: 4px;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: flex;
		justify-content: space-between;
		width: 100%;
		margin-bottom: 0;

		svg {
			display: block;
		}
	}
`;

const StyledFooterSectionHeader = styled(FooterSectionHeader)`
	text-align: left;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-bottom: 0;
	}
`;

interface IFooterLinkSectionProps extends IFooterLinkSection {
	isOpen: boolean;
	onClick: () => void;
}

export const FooterLinkSection = ({
	title,
	links,
	isOpen,
	onClick,
}: IFooterLinkSectionProps) => {
	const { t } = useTranslation();
	const submenuId = `footer-submenu-${title
		.toLowerCase()
		.replace(/\s+/g, '-')}`;

	return (
		<StyledFooterLinkSection role="navigation" aria-label={title}>
			<FooterSectionHeaderLinkDesktop>
				<StyledFooterSectionHeader styling="h3">
					{title}
				</StyledFooterSectionHeader>
			</FooterSectionHeaderLinkDesktop>

			<FooterSectionHeaderLink
				type="button"
				aria-expanded={isOpen}
				aria-controls={submenuId}
				aria-label={
					isOpen
						? t('nav_item_chevronup_label', { title })
						: t('nav_item_chevrondown_label', { title })
				}
				onKeyDown={(e) => handleKeyboardClick(e, onClick)}
				onClick={onClick}
			>
				<StyledFooterSectionHeader styling="h3">
					{title}
				</StyledFooterSectionHeader>

				{isOpen ? (
					<ChevronUpIcon variation="inverted" aria-hidden />
				) : (
					<ChevronDownIcon variation="inverted" aria-hidden />
				)}
			</FooterSectionHeaderLink>
			<FooterLinkList id={submenuId} links={links} isOpen={isOpen} />
		</StyledFooterLinkSection>
	);
};
